export class AppConfigService {
  get environment() {
    return window.genesisSettings.appEnvironment;
  }
}



// WEBPACK FOOTER //
// ./src/core/services/appConfig.service.js